import React, { useState, useRef, useEffect } from "react";
// import "../MailTemplate.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import SidebarMenu from "../../Widgets/SideBar Menu/SidebarMenu";
import { Link, useNavigate } from "react-router-dom";
import "./EditMail.css";
import {
  updateMailTemplate,
  checkMail,
  getMailTemplateDropdownOptions,
  getSingleMailTemplateOptions,
} from "../../../api";
import Loader from "../../Widgets/Loader/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";


import $ from 'jquery';
import 'summernote/dist/summernote-lite.css';
import 'summernote/dist/summernote-lite.js';


const EditMail = () => {
  const location = useLocation();
  const { id: stateId } = location.state || {};
  const searchParams = new URLSearchParams(location.search);
  const queryId = searchParams.get("id");

  const id = stateId || queryId; // ✅ pick from state OR query param

  const summernoteRef = useRef(null);


  const [editorContent, setEditorContent] = useState('');
  const [templateName, setTemplateName] = useState("");
  const [EnteredEmail, setEnteredEmail] = useState("");
  const [templateNames, setTemplateNames] = useState([]);


  useEffect(() => {

    // Initialize Summernote
    $(summernoteRef.current).summernote({
      height: 600,  // Set the height for the editor
      toolbar: [   // Customize the toolbar
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      callbacks: {
        // Capture changes to the content
        onChange: function(contents) {
          setEditorContent(contents);  // Save content to state
        }
      }
    });

    // Set the initial content in Summernote after fetching data
    if (editorContent) {
      $(summernoteRef.current).summernote('code', editorContent);
    }
  
    // Cleanup Summernote when the component unmounts
    return () => {
      $(summernoteRef.current).summernote('destroy');
    };

  }, [templateName]); // Add data.name to dependencies

  // Use useEffect to set content after summernote is initialized
  useEffect(() => {
    $(summernoteRef.current).summernote('code', editorContent);
  }, []);






  const handleEditorChange = (content) => {
    setEditorContent(content);
  };



  const getPopUpDataFunction = async () => {
    try {
      setLoading(true);

      const response = await getMailTemplateDropdownOptions();

      setLoading(false);

      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        setTemplateNames(response?.data?.response?.data);
      } else {
        setLoading(false);
        console.error(
          "Error fetching records:",
          response?.data?.error_msg || "Unknown error"
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching records:", error);
    }
  };

  useEffect(() => {
    getPopUpDataFunction();
  }, []);

  const [subject, setSubject] = useState("");
  const quillRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();



  const insertTextAtCursor = (text) => {
    // const editor = quillRef.current.getEditor();
    const editor = "";

    const range = editor.getSelection(true);
    editor.focus(); // Focus the editor
    editor.insertText(range.index, text);
    editor.setSelection(range.index + text.length);
  };

  const keywords = [
    "%personal_details_first_name%",
    "%personal_details_middle_name%",
    "%personal_details_surname_name%",
    "%occupation_occupation%",
    "%occupation_program%",
    "%pathway%",
    "%email_first_name%",
    "%email_surname_name%",
    "%unique_id%",
    "%email_signature%",
    "%occupation_reason_for_decline%",
    "%reason_for_decline%",
    "%day_date%",
    "%get_slot_time%",
    "%skill_title%",
    "%add_employment_referee_name%",
    "%add_employment_company_name%",
    "%s2_reason_for_decline%",
    "%s3_interview_day_and_date%",
    "%s3_interview_time%",
    "%s3_interview_venue%",
    "%s3_interview_address%",
    "%Expiry_Date%",
  ];

  EditMail.modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  EditMail.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];



  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate fields
    if (!templateName.trim()) {
      toast.error("Please select a template name.");
      setLoading(false);
      return;
    }

    if (!subject.trim()) {
      toast.error("Please fill in the subject.");
      setLoading(false);
      return;
    }

    if (!editorContent.trim()) {
      toast.error("Please fill in the email body.");
      setLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      // formData.append("name_keyword_id", templateName);
      formData.append("subject", subject);
      formData.append("body", editorContent);
      formData.append("id", id);

      setLoading(true);

      const response = await updateMailTemplate(formData);

      setLoading(false);

      if (
        response &&
        response.data &&
        response.data.response &&
        response.data.response.response === true
      ) {
        toast.success("Mail Template Updated Successfully.");
        // navigate("/admin/mail_template");
        // setTemplateName("");
        // setSubject("");
        // setEditorContent("");

        getAllDatForTemplateFunction();

      } else {
        console.error(
          "Error updating location data:",
          response?.data?.error_msg || "Unknown error"
        );
        toast.error(response?.data?.response?.error_msg || "Error in saving.");
      }
    } catch (error) {
      console.log("Error ", error);

      setLoading(false);
    } finally {
      setTemplateName("");
      setSubject("");
      setEditorContent("");
    }
  };

  // Handle email input change
  const handleEmailChange = (e) => {
    setEnteredEmail(e.target.value);
  };
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleCheckMail = async (event) => {
    event.preventDefault();

    // Validate email field
    if (!EnteredEmail.trim()) {
      toast.error("Please enter an email address.");
      setLoading(false);
      return;
    }

    if (!isValidEmail(EnteredEmail)) {
      toast.error("Please enter a valid email address.");
      setLoading(false);
      return;
    }
    try {
      const formData = new FormData();
      formData.append("mail", EnteredEmail);
      formData.append("id", id);

      setLoading(true);

      const response = await checkMail(formData);

      setLoading(false);

      if (
        response &&
        response.data &&
        response.data.response &&
        response.data.response.response === true
      ) {
        toast.success(
          response?.data?.response?.success_msg || "Mail Sended Successfully."
        );

        setEnteredEmail("");
      } else {
        console.error(
          "Error updating location data:",
          response?.data?.error_msg || "Unknown error"
        );
        toast.error(response?.data?.response?.error_msg || "Error in sending.");
      }
    } catch (error) {
      console.log("Error ", error);

      setLoading(false);
    } finally {
      setEnteredEmail("");
    }
  };

  const getAllDatForTemplateFunction = async () => {
    try {
      setLoading(true);

      const response = await getSingleMailTemplateOptions(id);

      setLoading(false);

      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        const data = response.data.response.data;
        setTemplateName(data.name || "");
        setSubject(data.subject || "");
        setEditorContent(data.body || "");
      } else {
        setLoading(false);
        console.error(
          "Error fetching records:",
          response?.data?.error_msg || "Unknown error"
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching records:", error);
    }
  };

  useEffect(() => {
    getAllDatForTemplateFunction();
  }, []);






  return (
    <>
      {loading && <Loader />}

      <div>
        <hr className="mb-2 thick-hr" />
        <div className="main-wrapper">
          <div className="sub-wrapper-sidebar">
            <SidebarMenu />
          </div>
          <div className="sub-wrapper-main mb-5 addmail_wrapper">
            <div className="main-heading-title">
              <h3 className="heading-admin-title text-color-green">
                Edit Mail Template
              </h3>
            </div>
            <div className="card shadow">
              <div>
                <form
                  id="test_f"
                  className="p-3 col-12 col-md-12"
                  onSubmit={handleCheckMail}
                >
                  <label htmlFor="email" className="col-3 label_mail p-0">
                    Email:
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="col-9 col-md-3"
                    value={EnteredEmail}
                    onChange={handleEmailChange}
                    required
                  />
                  {"  "}
                  <button
                    type="submit"
                    onClick={handleCheckMail}
                    className="test_mail_btn"
                  >
                    Test Email Send
                  </button>
                </form>
              </div>

              <div className="card-body">
                <form id="edit_form" onSubmit={handleSubmit}>
                  <div className="row g-0 card-header">
                    <div className="col-2 col-button1">
                      <button type="submit" className="btn btn_green_yellow">
                        Save Template
                      </button>
                    </div>
                    <div className="col-10 col-button2">
                      <Link
                        to="/admin/mail_template"
                        className="btn btn_yellow_green float-end"
                      >
                        <i className="bi bi-arrow-left "></i>
                        Back
                      </Link>
                    </div>
                  </div>
                  <div className="row card-body col_addmail">
                    <div className="col-8 column_first">
                      <div className="row my-2">
                        <div className="col-12">
                          <label>Name</label>
                          <select
                            name="template_name"
                            className="form-select"
                            id="template_id"
                            value={templateName}
                            onChange={(e) => setTemplateName(e.target.value)}
                            style={{ cursor: "pointer" }}
                            disabled
                          >
                            <option>{templateName}</option>

                            {/* <option value="">--Select Name--</option> */}
                            {/* {templateNames.map((template) => (
                              <option key={template.id} value={template.id}>
                                {template.name}
                              </option>
                            ))} */}
                            
                          </select>
                        </div>
                      </div>
                      <div className="row g-0 my-2">
                        <div className="col-12">
                          <label htmlFor="subjectField">Subject</label>
                          <input
                            type="text"
                            name="subject"
                            className="form-control subject"
                            id="subjectField"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="row g-0 my-2">
                        <div className="col-12">
                          <label htmlFor="quill">Body</label>
                        </div>


{/* 
                        <div className="quill">
                          <ReactQuill
                            ref={quillRef}
                            value={editorContent}
                            onChange={handleEditorChange}
                            modules={EditMail.modules}
                            formats={EditMail.formats}
                          />
                        </div> */}



                       <div ref={summernoteRef}></div>
                       


                        <div></div>
                      </div>
                    </div>
                    <div className="col-4 text-center column_second">
                      <div className="keyword-wrapper">
                      {keywords.map((keyword, index) => (
  <div key={index} className="keyword border my-2 rounded">
    <input
      type="button"
      value={keyword}
      className="btn input_btns btn_yg"
      onClick={() => {
        // Copy the keyword to the clipboard
        navigator.clipboard.writeText(keyword);

        // Show a success toast notification
        toast.success("Copied to clipboard");
      }}
    />
  </div>
))}


                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditMail;
